const recaptchaTokenKey = 'recaptchaToken';

function setRecaptchaToken(token: string) {
    localStorage.setItem(recaptchaTokenKey, token);
}

function getRecaptchaToken() {
    return localStorage.getItem(recaptchaTokenKey);
}

function isVerified() {
    return getRecaptchaToken() != null;
}

export default {
    setRecaptchaToken,
    getRecaptchaToken,
    isVerified,
};
